import React from 'react';
import api from '../../../Api';
import Title, { TitleImage } from '../../../types/Title';
import { CancelableRequestType } from '../../../types';

type UseTitleValue = {
	title: Title;
	isLoading: boolean;
	getJacketCoverImage: () => TitleImage | undefined;
};

export default function useTitle(
	sku: string,
	withFullDetails = false,
): UseTitleValue {
	const [isLoading, setIsLoading] = React.useState(true);
	const [title, setTitle] = React.useState<Title>({} as Title);

	const getJacketCoverImage = () =>
		title?.images?.find(im => im.type === 'jacketCover');

	React.useEffect(() => {
		let request: CancelableRequestType | undefined;

		const fetchTitle = async () => {
			try {
				const url = `/api/products/${sku}`;
				const urlForFullDetails = `${url}/images,links,descriptions`;
				request = api.cancelableGet(
					withFullDetails ? urlForFullDetails : url,
				);

				const title = await request?.promise;
				if (title) {
					setTitle(title);
				}
			} catch (error) {
				console.error(error);
			}
			setIsLoading(false);
		};

		fetchTitle();

		return () => {
			api.revoke(request);
		};
	}, [sku]);

	return {
		title,
		isLoading,
		getJacketCoverImage,
	};
}
